import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Activity, AlertCircle, RefreshCw } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-83">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col gap-6" data-id="element-84">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-85">
          El problema no es tu tolerancia al dolor.
        </h2>

        <p className="text-gray-700 text-base leading-relaxed" data-id="element-86">
          Tu cuerpo está en un estado de inflamación sistémica crónica. Cada
          mes, sin las herramientas correctas, ese fuego se reaviva. No alcanza
          con una pastilla. Necesitás un protocolo.
        </p>

        {/* Infographic / Timeline */}
        <div className="mt-6 flex flex-col gap-0 relative" data-id="element-87">
          {/* Connecting line */}
          <div className="absolute left-[1.3rem] top-6 bottom-6 w-0.5 bg-blush-light z-0" data-id="element-88"></div>

          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-89">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-90">
              <AlertCircle className="w-5 h-5 text-petroleo" data-id="element-91" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-92">
              <p className="font-semibold text-petroleo text-sm" data-id="element-93">
                Disparadores
              </p>
              <p className="text-xs text-gray-500" data-id="element-94">
                Alimentación, estrés, hormonas
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-95">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-96">
              <Activity className="w-5 h-5 text-petroleo" data-id="element-97" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-98">
              <p className="font-semibold text-petroleo text-sm" data-id="element-99">Inflamación</p>
              <p className="text-xs text-gray-500" data-id="element-100">El cuerpo se defiende</p>
            </div>
          </div>

          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-101">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-102">
              <Flame className="w-5 h-5 text-red-500" data-id="element-103" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-104">
              <p className="font-semibold text-petroleo text-sm" data-id="element-105">
                Dolor Crónico
              </p>
              <p className="text-xs text-gray-500" data-id="element-106">Crisis y agotamiento</p>
            </div>
          </div>

          <div className="flex items-center gap-4 relative z-10" data-id="element-107">
            <div className="w-11 h-11 rounded-full bg-petroleo border-2 border-petroleo flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-108">
              <RefreshCw className="w-5 h-5 text-white" data-id="element-109" />
            </div>
            <div className="bg-petroleo p-3 rounded-xl shadow-sm flex-grow" data-id="element-110">
              <p className="font-semibold text-white text-sm" data-id="element-111">
                Más Disparadores
              </p>
              <p className="text-xs text-salvia-light" data-id="element-112">El ciclo se repite</p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}